var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappApiMessaging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 380",
    fill: "none",
    role: "img",
    "aria-label": "Customer support and messaging",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 380,
    rx: 20,
    fill: "#EEF8F1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 220,
    height: 332,
    rx: 16,
    fill: "#fff",
    stroke: "#D7EBDD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 180,
    height: 36,
    rx: 10,
    fill: "#25D366",
    opacity: 0.12
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 12,
    fill: "#25D366",
    opacity: 0.35
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 54,
    width: 90,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 68,
    width: 60,
    height: 6,
    rx: 3,
    fill: "#25D366",
    opacity: 0.55
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 96,
    width: 132,
    height: 44,
    rx: 14,
    fill: "#F4F2FA"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 108,
    width: 96,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 122,
    width: 72,
    height: 6,
    rx: 3,
    fill: "#002454",
    opacity: 0.12
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 92,
    y: 152,
    width: 132,
    height: 44,
    rx: 14,
    fill: "#25D366",
    opacity: 0.85
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 164,
    width: 96,
    height: 8,
    rx: 4,
    fill: "#fff",
    opacity: 0.9
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 104,
    y: 178,
    width: 72,
    height: 6,
    rx: 3,
    fill: "#fff",
    opacity: 0.65
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 208,
    width: 148,
    height: 44,
    rx: 14,
    fill: "#F4F2FA"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 264,
    y: 24,
    width: 272,
    height: 332,
    rx: 16,
    fill: "#fff",
    stroke: "#D7EBDD"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 44,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.18
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 68,
    width: 232,
    height: 56,
    rx: 12,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 84,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.22
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 100,
    width: 180,
    height: 6,
    rx: 3,
    fill: "#002454",
    opacity: 0.12
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 140,
    width: 232,
    height: 56,
    rx: 12,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 156,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.22
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 172,
    width: 160,
    height: 6,
    rx: 3,
    fill: "#002454",
    opacity: 0.12
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 212,
    width: 232,
    height: 56,
    rx: 12,
    fill: "#EEF8F1",
    stroke: "#25D366",
    opacity: 0.35
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 228,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.22
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 244,
    width: 190,
    height: 6,
    rx: 3,
    fill: "#25D366",
    opacity: 0.45
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 284,
    y: 292,
    width: 112,
    height: 36,
    rx: 18,
    fill: "#25D366",
    opacity: 0.85
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappApiMessaging);
export default __webpack_public_path__ + "static/media/whatsapp-api-messaging.978b0f2ccddf176af5ffe118b69cad18.svg";
export { ForwardRef as ReactComponent };